import { ProductDto } from 'api/repositories/product/product.types';
import classNames from 'classnames';

const ProductListModal = (props: {
  products: Partial<ProductDto>[];
}) => {
  console.log('[product]', props.products)
  return (
    <>
      <div className={classNames([
        "py-8 px-4 w-full",
        "flex flex-col",
        "bg-white rounded-[4px] text-[12px]",
      ])}>
        <div className="py-1 font-bold tracking-tighter text-xl">
          DEBUG : CURRENT CAMPAIGN PRODUCTS
        </div>
        <div className="text-[12px] text-[#999]">{`* 마스터 로그인에서만 보입니다`}</div>
        {/* HEADER */}
        <div className={classNames([
          "mt-4 p-2 w-full",
          "grid grid-cols-[1fr_8fr_2fr_1fr_1fr_1fr] gap-3",
          "bg-[#F5F5F5] border-b border-[#E5E5E5] font-bold",
        ])}>
          <div>ID</div>
          <div>NAME</div>
          <div>COLOR_NAME</div>
          <div>QTY</div>
          <div>STATUS</div>
          <div>IS_USE</div>
        </div>
        {/* PRODUCTS */}
        {props.products.map((product) => (
          <div
            key={product.id}
            data-product-id={product.id}
            className={classNames([
              "p-2 w-full",
              "grid grid-cols-[1fr_8fr_2fr_1fr_1fr_1fr] gap-3",
              "border-b border-[#E5E5E5]",
            ])}
          >
            <div>{product.id ?? '-'}</div>
            <div>{product.name ?? '-'}</div>
            <div>{product.colorName ?? '-'}</div>
            <div className="text-center">{product.qty ?? '-'}</div>
            <div className="text-center">{product.statusFl ?? '-'}</div>
            <div className="text-center">{product.isUse ?? '-'}</div>
          </div>
        ))}
      </div>
    </>
  );
};

export default ProductListModal;
